/**
 * @category    ScandiPWA
 * @package     ScandiPWA_CjPublicis
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2022 Scandiweb, Ltd (https://scandiweb.com)
 */

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { fetchQuery } from 'Util/Request/Query';

import CookieQuery from '../../query/Cookie.query';

/** @namespace Cjpublicis/Component/CookieScript/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Cjpublicis/Component/CookieScript/Container */
export class CookieScriptContainer extends PureComponent {
    componentDidMount() {
        if (window.hasLoaded) {
            this.injectCookieScript();
            return;
        }

        window.addEventListener('load', () => {
            this.injectCookieScript();
            window.hasLoaded = true;
        });
    }

    componentDidUpdate() {
        const script = document.getElementById('cjapitag');
        if (!script) {
            this.injectCookieScript();
        }
    }

    componentWillUnmount() {
        this.removeCookieScripts();
    }

    injectCookieScript() {
        fetchQuery(CookieQuery.getCookieData(new URLSearchParams(window.location.search).get('cjevent'))).then(
            /** @namespace Cjpublicis/Component/CookieScript/Container/CookieScriptContainer/injectCookieScript/fetchQuery/then */
            (result) => {
                if (result) {
                    const { getCookie: { encoded_url, tag_id } } = result;
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.text = `(function(a,b,c,d){
                            a='https://www.mczbf.com/tags/${ tag_id }/tag.js';
                            b=document;c='script';d=b.createElement(c);d.src=a;
                            d.type='text/java'+c;d.async=true;
                            d.id='cjapitag';
                            a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
                        })()`;

                    if (encoded_url && tag_id) {
                        document.head.insertBefore(script, document.head.childNodes[0]);
                    }
                }
            }
        );
    }

    removeCookieScripts() {
        const script = document.getElementById('cjapitag');
        if (script) {
            script.remove();
        }
    }

    render() {
        return null;
    }
}

export default withRouter(connect(mapDispatchToProps)(CookieScriptContainer));
